// AdminSchema.js
// Matches the same shape/style as PermissionGroupSchema.js
import { DATE_TIME_FORMAT_REG_EXP } from "utils/datetime";

export const terminalsFormSchema = [
  {
    id: "id",
    dataType: "integer",
    shownOnForm: false,
    label: "ID",
    value: 0,
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "code",
    dataType: "Text",
    shownOnForm: true,
    label: "Code",
    value: "",
    isRequired: true,
    maxChar: 30,
    fieldType: "textfield",
    pattern: /^[a-zA-Z0-9\-\_]+$/,
    patternMessage:
      "Invalid code. You can use letters, numbers or characters such as -, _ e.g A0001-001",
  },
  {
    id: "terminalName",
    dataType: "Text",
    shownOnForm: true,
    label: "Terminal Name",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
  },
  {
    id: "terminalType",
    dataType: "Text",
    shownOnForm: true,
    label: "Terminal Type",
    value: "active",
    isRequired: true,
    maxChar: 50,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "Virtual Terminal", label: "Virtual Terminal" },
      { value: "Terminal", label: "Terminal" },
    ],
  },
  {
    id: "hospitalCode",
    dataType: "Text",
    shownOnForm: true,
    label: "Hospital Code",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
    pattern: /^[a-zA-Z0-9\-\_\s]+$/,
    patternMessage: "Invalid hospital code. Only letters and numbers are required",
  },
  {
    id: "hospitalName",
    dataType: "Text",
    shownOnForm: true,
    label: "Hospital Name",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
    pattern: /^[a-zA-Z0-9\-\_\s\$\&\(\)]+$/,
    patternMessage: "Invalid hospital name. Only letters and numbers are required",
  },
  {
    id: "status",
    dataType: "Text",
    shownOnForm: true,
    label: "Status",
    value: "active",
    isRequired: true,
    maxChar: 50,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "Active", label: "Active" },
      { value: "Inactive", label: "Inactive" },
    ],
  },
  {
    id: "terminalUsers",
    label: "Terminal Users",
    fieldType: "dynamicList",
    shownOnForm: true,
    isRequired: false,
    columns: [
      {
        id: "name",
        label: "User's Full Name",
        type: "textfield",
        isRequired: true,
        width: 200,
      },
      {
        id: "username",
        label: "Username",
        type: "textfield",
        isRequired: true,
        width: 200,
      },
      {
        id: "password",
        label: "Password",
        type: "password",
        isRequired: true,
        width: 200,
      },
      {
        id: "email",
        label: "Email",
        type: "textfield",
        isRequired: true,
        width: 200,
      },
      {
        id: "phone",
        label: "Phone Number",
        type: "textfield",
        isRequired: true,
        width: 200,
      },
      {
        id: "status",
        label: "Status",
        type: "select",
        isRequired: true,
        width: 200,
        options: () => [
          { value: "Active", label: "Active" },
          { value: "Inactive", label: "Inactive" },
        ],
      },
    ],
  },
];

export const terminalsRecord = {
  id: 0,
  code: "",
  terminalName: "",
  status: "active",
  hospitalCode: "",
  hospitalName: "",
  terminalType: "",
  terminalUsers: [],
};
